import { Entity, validatedResource, resource } from 'aurelia-orm';
import { ValidationRules } from 'aurelia-validation';
import { autoinject } from 'aurelia-framework';

@resource("ganttinfo")
@validatedResource()
export class GanttInfo extends Entity {
	id: number;
	name: string;
	startDate: Date;
	endDate: Date;
	progress: number;
	resources: number;
	duration: number;
	predecessor: string;
	parentId: number;
	children: Array<GanttInfo>;
	baselineStartDate: Date;
	baselineEndDate: Date;
}